import { render } from "./ApplicantSystemCheck.vue?vue&type=template&id=06d77de7&scoped=true"
import script from "./ApplicantSystemCheck.vue?vue&type=script&lang=ts"
export * from "./ApplicantSystemCheck.vue?vue&type=script&lang=ts"

import "./ApplicantSystemCheck.vue?vue&type=style&index=0&id=06d77de7&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-06d77de7"
/* custom blocks */
import block0 from "./ApplicantSystemCheck.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script